export default class IdentityCard
{
    constructor(type, cardId, divId, isMandatory, onChange)
    {
		this.divId = divId;
        this.type = type;
        this.cardId = this.normalize(cardId);
        this.isMandatory = isMandatory;
        this.onChange = onChange;
        this.documentChoices;
    }
    
	paintIdentityCardHTML()
    {
		let identityCardsDiv = document.getElementById(this.divId);
		
		if(identityCardsDiv == null)
		{
			return;
		}
		
		let html = '<div id="billingDocumentType" class="large-4 medium-12 columns" style="padding-right:0">'
				+ '<label style="max-width:8rem; text-overflow:ellipsis; overflow:hidden; text-wrap:nowrap;">' + polyglot.t("identity_cards.Document_type") + '</label>'
				+ '<select id="' + this.divId + 'DocumentInvoiced"></select>'
			+ '</div>'
			+ 	'<div class="large-8 medium-12 columns">'
					+ '<label>' + polyglot.t('identity_cards.Document_number') + '</label>'
					+ '<input type="text" maxlength="25" id="taxId" name="taxId" autocomplete="off" placeholder="' + polyglot.t('identity_cards.Document_number') + '" ' + (this.onChange != null ? ' onchange="' + this.onChange + '" />' : '/>')
			+ '</div>';
		
		identityCardsDiv.innerHTML = html;
		
		this.loadComboDocuments();
	}
	
	loadComboDocuments()
	{
		if(document.getElementById(this.divId + 'DocumentInvoiced') == null)
		{
			return;
		}
		
		if(this.documentChoices != null)
		{
			this.documentChoices.destroy();
		}
		
		this.documentChoices = new Choices('#' + this.divId + 'DocumentInvoiced',
		{
	        removeItemButton: false,
	        duplicateItemsAllowed: false,
			searchEnabled: true,
			searchResultLimit: 25,
			callbackOnInit: function() {
				this.setChoices(IdCardTypes, 'idCardType', 'litCardType', true);
		    },	
		});
		
		// Use Choices.js event system to listen for changes
		let selectElement = document.getElementById(this.divId + 'DocumentInvoiced');
		if(selectElement != null)
		{
			selectElement.addEventListener('change', () => {
				this.updatePlaceholder();
				if(this.onChange != null)
				{
					eval(this.onChange);
				}
			});
		}
		
		if(this.type != null)
	    {
	    	this.documentChoices.setChoiceByValue(this.type);
	    }
	
	    addAutotestChoicesIds(this.divId + 'DocumentInvoiced');
	    
	    this.updatePlaceholder();
	}
	
	updatePlaceholder()
	{
		let selectElement = document.querySelector('#' + this.divId + ' #' + this.divId + 'DocumentInvoiced');
		let inputElement = document.querySelector('#' + this.divId + ' #taxId');
		
		if(selectElement != null && inputElement != null)
		{
			let selectedOption = selectElement.options[selectElement.selectedIndex];
			if(selectedOption != null && selectedOption.text != null)
			{
				inputElement.placeholder = selectedOption.text;
			}
		}
	}
	
	checkGenericIdentityCardData()
	{
		this.type = document.querySelector('#' + this.divId + ' #' + this.divId +'DocumentInvoiced') != null ? document.querySelector('#' + this.divId + ' #' + this.divId +'DocumentInvoiced').value : null;
		this.cardId = document.querySelector('#' + this.divId + ' #taxId') != null ? document.querySelector('#' + this.divId + ' #taxId').value : null;
		
		if(this.cardId)
		{
			if(!this.type)
			{
				alertaKO(polyglot.t("customers.Fill_nif_type"));
				return false;
			}
			else if(!IdentityCard.create(this.type, this.cardId).validate())
			{
				alertaKO(polyglot.t("customers.Incorrect_nif"));
				return false;
			}
		}
		
		return true;
	}
	
	getBuyerIdentityCardData(buyer)
	{		
		if(!this.checkGenericIdentityCardData())
		{
			return false;
		}
		
		buyer.nif = this.cardId;
		buyer.idCardType = this.type;
		
		return buyer;
	}
	
	fillGenericIdentityCardFields(cardId, cardTypeId)
	{
		this.cardId = cardId;
		this.type = cardTypeId;
		if(document.querySelector('#' + this.divId + ' #taxId') != null) document.querySelector('#' + this.divId + ' #taxId').value = this.cardId;
		this.loadComboDocuments();
	}
	
	resetIdentityCardFields()
	{
		this.cardId = null;
		this.type = null;
		
		if(document.querySelector('#' + this.divId + ' #taxId') != null)
		{
			document.querySelector('#' + this.divId + ' #taxId').value = null;
			this.loadComboDocuments();
		}
	}

    normalize(cardId)
    {
        // Here we can write generic code to normalize the identity document cardId
        // for example, removing white spaces or hyphens
    }

    validate()
    {
        // empty
    }

    static create(type, cardId)
    {
        // Create an identity document object of the specified type
        if(type == IdCardType.RUT_CL) 
        {
            return new ChileanRut(cardId);
        }
        else if(type == IdCardType.DNI_ES) 
        {
            return new SpanishDni(cardId);
        }
        else if(type == IdCardType.CPF_BR) 
        {
            return new BrazilianCpf(cardId);
        }
        else if(type == IdCardType.CNPJ_BR) 
        {
            return new BrazilianCnpj(cardId);
        }
        else if(type == IdCardType.PASSPORT)
        {
            return new Passport(cardId);
        }
        else if(type == IdCardType.NIE_ES) 
        {
            return new SpanishNie(cardId);
        }
        else if(type == IdCardType.CIF_ES) 
        {
            return new SpanishCif(cardId);
        }
        else if(type == IdCardType.DNI_PE) 
        {
            //return new PeruvianDni(cardId);
            return new GenericNumericLengthIdentityCard('DNI_PE', cardId, 8);
        }
        else if(type == IdCardType.PESEL_PL) 
        {
            return new PolishPesel(cardId);
        }
        else if(type == IdCardType.RNC_DO)
        {
            //return new DominicanRnc(cardId);
			return new GenericNumericRangeIdentityCard('DoRNC', cardId, 9, 11);
        }
        else if(type == IdCardType.CEDULA_DO)
        {
            return new GenericNumericRangeIdentityCard('DoCedula', cardId, 9, 11);
        }
        else if(type == IdCardType.NIT_CO)
        {
            return new GenericAlphaNumericIdentityCard('CoNit',cardId);
        }
        else if(type == IdCardType.CEDULACIUDADANIA_CO)
        {
            return new GenericNumericIdentityCard('CoCedula',cardId);
        }
        else if(type == IdCardType.TARJETAIDENTIDAD_CO)
        {
            return new GenericAlphaNumericIdentityCard('CoTarjeta',cardId);
        }
        else if(type == IdCardType.CEDULAEXTRANJERIA_CO)
        {
            return new GenericAlphaNumericIdentityCard('CoCedulaExtranjeria',cardId);
        }
        else if(type == IdCardType.UY_CEDULA) 
        {
			//TODO: Add algorithm
            //return new UruguayanCedula(cardId);
            return new GenericNumericRangeIdentityCard('UyCedula', cardId, 7, 8);
        }
        else if(type == IdCardType.UY_RUT) 
        {
			//TODO: Add algorithm
            //return new UruguayanRut(cardId);
            return new GenericNumericLengthIdentityCard('UyRut', cardId, 12);
        }
        else if(type == IdCardType.UY_NIE) 
        {
			//TODO: Add algorithm
            //return new UruguayanNie(cardId);
            return new GenericNumericLengthIdentityCard('UyNie', cardId, 9);
        }
/*
		//TODO: Check format and validation algorithm of following id card types
		else if(type == IdCardType.BolivianIdCard)
        {
            return new GenericNumericRangeIdentityCard('Cédula de Identidad', cardId, 7, 8);
        }
        else if(type == IdCardType.EcuadorianIdCard)
        {
            return new GenericNumericLengthIdentityCard('Cédula de Identidad', cardId, 10);
        }
        else if(type == IdCardType.VenezuelanIdCard)
        {
            return new GenericNumericRangeIdentityCard('Cédula de Identidad', cardId, 7, 8);
        }
        else if(type == IdCardType.UruguayanDnic)
        {
            return new GenericNumericLengthIdentityCard('DNIC', cardId, 8);
        }
        else if(type == IdCardType.ArgentineDni)
        {
            return new GenericNumericRangeIdentityCard('DNI', cardId, 7, 8);
        }
        else if(type == IdCardType.ColombianIdentityCard)
        {
            return new GenericNumericRangeIdentityCard('DI Colombia', cardId, 8, 10);
        }
        else if(type == IdCardType.ParaguayanIdCard)
        {
            return new GenericNumericRangeIdentityCard('Cédula de Identidad Civil', cardId, 7, 8);
        }
*/
		else 
        {
            return new NotDefinedCard(cardId);
        }
    }
}


class NotDefinedCard extends IdentityCard
{
    constructor(cardId)
    {
        super('Not defined card', cardId);
    }
    
    validate() 
    {
        return true;
    }
}
 

class GenericIdentityCard extends IdentityCard 
{
    constructor(type, cardId) 
    {
        super(type, cardId);
    }

    normalize(cardId) 
    {
        return cardId;
    }

    validate() 
    {
		return true;
    }

}

class GenericNumericIdentityCard extends IdentityCard 
{
    constructor(type, cardId) 
    {
        super(type, cardId);
    }

    normalize(cardId) 
    {
        return cardId;
    }

    validate() 
    {
    	const regex = /^[0-9]+$/;
    	return regex.test(this.cardId);
    }
}

class GenericNumericLengthIdentityCard extends IdentityCard 
{
    constructor(type, cardId, length) 
    {
        super(type, cardId);
		this.length = length;
    }

    normalize(cardId) 
    {
        return cardId;
    }

    validate() 
    {
        const regex = `^(\\d{${this.length}})$`;
        var matcher = new RegExp(regex);
        return matcher.test(this.cardId);
    }
}

class GenericNumericRangeIdentityCard extends IdentityCard 
{
    constructor(type, cardId, min, max) 
    {
        super(type, cardId);
        this.min = min;
        this.max = max;
    }

    normalize(cardId) 
    {
        return cardId;
    }

    validate() 
    {
       const regex = `^(\\d{${this.min},${this.max}})$`;
       var matcher = new RegExp(regex);
       return matcher.test(this.cardId);
    }

}

class GenericAlphaNumericIdentityCard extends IdentityCard 
{
    constructor(type, cardId) 
    {
        super(type, cardId);
    }

    normalize(cardId) 
    {
        return cardId.trim().toUpperCase();
    }

    validate() 
    {
        const regex = /^[a-zA-Z0-9\-]+$/;
		return regex.test(this.cardId);
    }
}

 
class SpanishDni extends IdentityCard
{
    constructor(cardId)
    {
        super('Spanish DNI', cardId);
    }
    
    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }
    
    validate() 
    {
        // We override the validate method to check that the Spanish DNI cardId is correct
        const regex_dni = /^\d{8}[A-Z]$/;

        let dni = this.cardId;
        let numero = null;
        
        if(regex_dni.test(this.cardId))
        {
            numero = dni.substr(0,dni.length-1);
        }
        else
        {
            return false;	
        }
        
        const letr = dni.substr(dni.length-1,1);
        numero = numero % 23;
        let letra='TRWAGMYFPDXBNJZSQVHLCKET';
        letra=letra.substring(numero,numero+1);
        return letra == letr.toUpperCase();
    }
}

class SpanishCif extends IdentityCard 
{
    constructor(cardId) 
    {
        super('Spanish CIF', cardId);
    }
    
    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }
    
    validate() 
    {

        if (!this.cardId || this.cardId.length !== 9)
        {
            return false;
        }
    
        const letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
        const digits = this.cardId.substr(1, this.cardId.length - 2);
        const letter = this.cardId.substr(0, 1);
        const control = this.cardId.substr(this.cardId.length - 1);
        let sum = 0;
        let digit;
    
        if (!letter.match(/[A-Z]/))
        {
            return false;
        }
    
        for (let i = 0; i < digits.length; ++i)
        {
            digit = parseInt(digits[i]);
    
            if (isNaN(digit))
            {
                return false;
            }
    
            if (i % 2 === 0)
            {
                digit *= 2;

                if (digit > 9)
                {
                    digit = parseInt(digit / 10) + (digit % 10);
                }
    
                sum += digit;
            }
            else
            {
                sum += digit;
            }
        }
    
        sum %= 10;

        if (sum !== 0)
        {
            digit = 10 - sum;
        }
        else
        {
            digit = sum;
        }
    
        if (letter.match(/[ABEH]/))
        {
            return String(digit) === control;
        }

        if (letter.match(/[NPQRSW]/))
        {
            return letters[digit] === control;
        }
    
        return String(digit) === control || letters[digit] === control;
    }
}

class SpanishNie extends IdentityCard 
{

    constructor(cardId) 
    {
        super('Spanish NIE', cardId);
    }
    
    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }
    
    validate() 
    {
        const nieRegex = /^[XYZ]\d{7}[a-zA-Z]$/;

        if (!nieRegex.test(this.cardId))
        {
            return false;
        }
    
        const controlLetters = this.cardId.charAt(8).toUpperCase();
        const firstChar = this.cardId.charAt(0);
    
        let NieCardId = this.cardId.substring(1, 8);
    
        switch (firstChar) 
        {
            case 'X':
                NieCardId = '0' + NieCardId;
                break;
            case 'Y':
                NieCardId = '1' + NieCardId;
                break;
            case 'Z':
                NieCardId = '2' + NieCardId;
                break;
            default:
                return false;
        }
    
        return new SpanishDni(NieCardId + controlLetters).validate();
    }
}

class Passport extends IdentityCard 
{
    constructor(cardId) 
    {
        super('Passport', cardId);
    }

    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }

    validate() 
    {
        // We override the validate method to check that the passport cardId is correct
        const regex = /^[A-Z0-9]{8,9}$/;
        return regex.test(this.cardId);
    }
}

class ChileanRut extends IdentityCard 
{
    constructor(cardId) 
    {
        super('RUT', cardId);
    }

    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces, hyphens and dots, and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }

    validate() 
    {
        // We override the validate method to check that the Chilean RUT cardId is correct
        const regex = /^\d{7,8}[0-9K]$/;

        const cardId = this.cardId.replace(/-|\./g, '');

        if (!regex.test(cardId)) 
        {
            return false;
        }

        const rut = cardId.slice(0, -1);
        const dv = cardId.slice(-1);
        return this.calculateDv(rut) === dv;
    }

    calculateDv(rut) 
    {
        // This function calculates the verification digit (DV) for a Chilean RUT
        let sum = 0;
        let mul = 2;

        for (let i = rut.length - 1; i >= 0; i--)
        {
            sum += rut.charAt(i) * mul;
            mul = mul % 7 === 0 ? 2 : mul + 1;
        }

        const dv = 11 - sum % 11;
        return dv === 11 ? '0' : dv === 10 ? 'K' : String(dv);
    }
}

class BrazilianCpf extends IdentityCard 
{
    constructor(cardId) 
    {
        super('CPF', cardId);
    }

    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces, hyphens and dots, and convert letters to uppercase
        return cardId.trim().replace(/-|\./g, '').toUpperCase();
    }

    validate() 
    {
        // We override the validate method to check that the Brazilian CPF cardId is correct
        const regex = /^\d{11}$/;

        if (!regex.test(this.cardId)) 
        {
            return false;
        }

        const cpf = this.cardId;
        const firstDv = this.calculateDv(cpf.slice(0, 9));
        const secondDv = this.calculateDv(cpf.slice(0, 9) + firstDv);
        return firstDv === cpf.slice(9, 10) && secondDv === cpf.slice(10, 11);
    }

    calculateDv(cardId) 
    {
        // This function calculates the verification digit (DV) for a Brazilian CPF
        let sum = 0;

        for (let i = 0; i < cardId.length - 1; i++) 
        {
            sum += parseInt(cardId.charAt(i), 10) * (cardId.length - i);
        }

        const dv = 11 - sum % 11;
        return dv > 9 ? '0' : String(dv);
    }
}

class BrazilianCnpj extends IdentityCard 
{
    constructor(cardId) 
    {
        super('CNPJ', cardId);
    }

    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces, hyphens and dots, and convert letters to uppercase
        return cardId.trim().replace(/-|\./g, '').toUpperCase();
    }

    validate() 
    {
        // We override the validate method to check that the Brazilian CNPJ cardId is correct
        const regex = /^\d{14}$/;

        if (!regex.test(this.cardId)) 
        {
            return false;
        }

        const cnpj = this.cardId;
        const firstDv = this.calculateDv(cnpj.slice(0, 12));
        const secondDv = this.calculateDv(cnpj.slice(0, 12) + firstDv);
        
        return firstDv === cnpj.slice(12, 13) && secondDv === cnpj.slice(13, 14);
    }

    calculateDv(cardId) 
    {
        // This function calculates the verification digit (DV) for a Brazilian CNPJ
        let sum = 0;
        let weight = 2;
        
        for (let i = cardId.length - 1; i >= 0; i--) 
        {
            sum += parseInt(cardId.charAt(i), 10) * weight;
            weight = weight % 9 + 1;
        }

        const dv = sum % 11 < 2 ? 0 : 11 - sum % 11;
        return String(dv);
    }
}

class PolishPesel extends IdentityCard 
{
    constructor(cardId) 
    {
        super('PESEL', cardId);
    }

    normalize(cardId) 
    {
        // We override the normalize method to remove white spaces and convert letters to uppercase
        return cardId.trim().toUpperCase();
    }

    validate() 
    {
        // We override the validate method to check that the Polish PESEL cardId is correct
        const regex = /^\d{11}$/;

        if (!regex.test(this.cardId)) 
        {
            return false;
        }

        const pesel = this.cardId;
        const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
        let sum = 0;
        
        for (let i = 0; i < pesel.length - 1; i++) 
        {
            sum += parseInt(pesel.charAt(i), 10) * weights[i];
        }

        const dv = 10 - sum % 10;
        return String(dv) === pesel.slice(-1);
    }
}

